module.exports = __webpack_public_path__ + "img/sksww.77096527.jpg";